import {
	REQUEST_GET_APPLICATION_STATUSES, RECEIVE_GET_APPLICATION_STATUSES, RECEIVE_BAD_REQUEST_GET_APPLICATION_STATUSES,
	// RECEIVE_SUB_CASE_TYPES, REQUEST_SUB_CASE_TYPES
} from "../actions/index";

const defaultState = {
	statuses: [],
	fetching: false,
	badFetchResponse: ''
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case REQUEST_GET_APPLICATION_STATUSES:
			return {
				...state,
				fetching: true
			};
		case RECEIVE_GET_APPLICATION_STATUSES:
			return {
				...state,
				fetching: false,
				statuses: action.payload
			};
		case RECEIVE_BAD_REQUEST_GET_APPLICATION_STATUSES:
			return {
				...state,
				fetching: false,
				badFetchResponse: action.payload
			};
		default:
			return state
	}
}